var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart10 = function SvgBarChart10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M5.25 4.083H2.683c-.326 0-.49 0-.614.064a.6.6 0 0 0-.255.255c-.064.125-.064.288-.064.615v6.3c0 .326 0 .49.064.614.056.11.145.2.255.255.124.064.288.064.614.064H5.25m0 0h3.5m-3.5 0V2.683c0-.326 0-.49.064-.614a.6.6 0 0 1 .255-.255c.124-.064.288-.064.614-.064h1.634c.326 0 .49 0 .614.064.11.056.2.145.255.255.064.124.064.288.064.614v9.567m0-5.833h2.567c.326 0 .49 0 .614.063.11.056.2.145.255.255.064.125.064.288.064.615v3.967c0 .326 0 .49-.064.614a.6.6 0 0 1-.255.255c-.124.064-.288.064-.614.064H8.75"
  })));
};
export default SvgBarChart10;